import collectionUtils from '../../../common/collection-utils';

angular.module('cian.metroBrowser').directive('metroStation', ['$sce', function($sce) {
  return {
    scope: {},
    template: require('../../templates/metro-svg-browser.station.html'),
    templateNamespace: 'svg',
    restrict: 'A',
    bindToController: {
      stationData: '<',
      metroState: '='
    },
    controller: [function() {
      this.getTranslate = (obj) => `translate(${obj.x} ${obj.y})`;

      this.getTranslateForText = ({x: textX, y: textY}, {x: pointX, y: pointY}) => {
        // Так как точка может смещаться на дробное значение, а текст мы хотим смещать по целому значению
        // Вычитаем из целого смещения текста дробную часть точки
        const finalCoords = {
          x: (Math.round(textX) - (pointX % 1)).toFixed(2),
          y: (Math.round(textY) - (pointY % 1)).toFixed(2)
        };

        return this.getTranslate(finalCoords);
      };

      this.trust = (...args) => $sce.trustAsHtml.apply(this, args);

      this.handleClick = (e) => {
        this.metroState.stations[this.stationData.id].isActive = !this.metroState.stations[this.stationData.id].isActive;
      };

      this.handleMouseEnter = (e) => {
        this.metroState.stations[this.stationData.id].isHover = true;
      };

      this.handleMouseLeave = (e) => {
        this.metroState.stations[this.stationData.id].isHover = false;
      };

      this.getCircleRadius = () => this.isActive() ? 6.75 : 5.5;

      this.isActive = () => this.metroState.stations[this.stationData.id].isActive;
      this.isHover = () => this.metroState.stations[this.stationData.id].isHover;
    }],
    controllerAs: 'stationCtrl'
  };
}]);



// WEBPACK FOOTER //
// ./src/components/metro-browser/src/scripts/cian.metro-svg-browser.station.dir.js